csui.require.config({
  bundles: {
'csui/bundles/csui-libraries': [
'csui/lib/binf/js/binf',
'csui/lib/binf/js/binf-switch',
'csui/lib/fastclick',
'csui/lib/hammer',
'csui/lib/jquery.redraw',
'csui/lib/jquery.renametag',
'csui/lib/jquery.scrollbarwidth',
'csui/lib/jquery.touchSwipe',
'csui/lib/jquery.ui/js/jquery-ui',
'csui/lib/perfect-scrollbar',
'csui/lib/exif'
],
'csui/bundles/csui-models': [
'csui/models/audit/audit.collection',
'csui/models/authenticated.user.node.permission',
'csui/models/favorite2',
'csui/models/favorite2group',
'csui/models/favorite2groups',
'csui/models/favorites2',
'csui/models/favorite2column',
'csui/models/favorite2columns',
'csui/models/favorite.model',
'csui/models/permission/nodepermission.model',
'csui/models/permission/nodeuserpermissions',
'csui/models/server.module/server.module.collection',
'csui/models/specificnodemodel',
'csui/models/version',
'csui/models/view.state.model',
'csui/models/perspective/personalization.model',
'csui/models/perspective/personalize/delta.generator',
'csui/models/perspective/personalize/delta.resolver',
'csui/models/memberancestorcollection',
'csui/models/perspective/perspective.model',
'csui/models/perspective/perspective.template.model',
'csui/models/perspective/personalize/personalization.collection',
'csui/models/perspective/perspective.collection/perspective.collection',
'csui/models/widget/widget.collection',
'csui/models/widget/widget.model',
'csui/models/zipanddownload/zipanddownload.preflight',
'csui/models/zipanddownload/zipanddownload.stages',
'csui/models/impl/nls/lang',
'csui/utils/base',
'csui/utils/mime.types',
'csui/utils/classic.nodes/classic.nodes',
'csui/utils/defaultactionitems',
'csui/utils/nodesprites',
'csui/utils/node.info.sprites',
'csui/utils/impl/nls/lang',
'csui/utils/promoted.actionitems',
'csui/utils/smart.nodes/smart.nodes',
'csui/utils/perspective/perspective.util',
'csui/utils/user.session/user.session',
'csui/utils/exp.widget.config',
'csui/utils/authenticators/core.authenticators',
'csui/utils/authenticators/interactive.credentials.authenticator',
'csui/utils/authenticators/redirecting.form.authenticator',
'csui/themes/csui.jato.mime.icons',
'csui/models/audit/server.adaptor.mixin',
'csui/models/node.createform/server.adaptor.mixin',
'csui/models/permission/server.adaptor.mixin',
'csui/models/permission/permission.action.server.adaptor.mixin',
'csui/models/server.info/server.adaptor.mixin',
'csui/models/permission/permission.precheck.server.adaptor',
'csui/models/appliedcategories/category',
'csui/models/appliedcategories/category.server.adaptor.mixin',
'csui/models/appliedcategories/systemattributes.model',
'csui/models/appliedcategories/systemattributes.server.adaptor.mixin',
'csui/models/appliedcategories/category.validation.server.adaptor.mixin',
'csui/models/appliedcategories/category.validation.model',
'csui/models/navigation.history'
],
'csui/bundles/csui-server-adaptors': [

],
'csui/bundles/csui-commands': [
'csui/utils/commonconfig.util',
'csui/utils/commands/back.to.last.fragment',
'csui/integration/folderbrowser/commands/go.to.node.history',
'csui/integration/folderbrowser/commands/open.full.page.container',
'csui/integration/folderbrowser2/commands/open.full.page.container',
'csui/utils/commands',
'csui/utils/commands/add/add.mixin',
'csui/utils/commands/add.categories',
'csui/utils/commands/add',
'csui/utils/commands/add.item.metadata',
'csui/utils/commands/add.version',
'csui/utils/commands/browse',
'csui/utils/commands/collection/collect.items',
'csui/utils/commands/collection/remove.collected.items',
'csui/utils/commands/confirmable',
'csui/utils/commands/copy',
'csui/utils/commands/copy.link',
'csui/utils/commands/create.perspective',
'csui/utils/commands/delete',
'csui/utils/commands/delete/delete.self.handler',
'csui/utils/commands/download',
'csui/utils/commands/open.mixin',
'csui/utils/commands/open.in.browser',
'csui/utils/commands/open.base',
'csui/utils/commands/open.document/open.document',
'csui/utils/commands/preview.plugins/preview.plugins',
'csui/utils/commands/zipanddownload',
'csui/utils/commands/edit.perspective',
'csui/utils/commands/edit.multiple.perspectives',
'csui/utils/commands/manage.branding',
'csui/utils/commands/editwebdav',
'csui/utils/commands/email.link',
'csui/utils/commands/execute.saved.query',
'csui/utils/commands/execute.search.form.query',
'csui/utils/commands/favorite.add',
'csui/utils/commands/favorite.remove',
'csui/utils/commands/inlineedit',
'csui/utils/commands/move',
'csui/utils/commands/multiple.items',
'csui/utils/commands/navigate',
'csui/utils/commands/node',
'csui/utils/commands/open',
'csui/utils/commands/open.node.perspective',
'csui/utils/commands/open.classic.page',
'csui/utils/commands/open.discussion',
'csui/utils/commands/open.milestone',
'csui/utils/commands/open.channel',
'csui/utils/commands/open.news',
'csui/utils/commands/open.poll',
'csui/utils/commands/open.prospector',
'csui/utils/commands/open.specific.classic.page',
'csui/utils/commands/open.specific.node.perspective',
'csui/utils/commands/open.task',
'csui/utils/commands/open.taskgroup',
'csui/utils/commands/open.tasklist',
'csui/utils/commands/open.topic',
'csui/utils/commands/permissions',
'csui/utils/commands/properties',
'csui/utils/commands/rename',
'csui/utils/commands/rename.favorite',
'csui/utils/commands/reserve',
'csui/utils/commands/request.reservation',
'csui/utils/commands/compound.document/compound.document.util',
'csui/utils/commands/run.livereport',
'csui/utils/commands/sign.out',
'csui/utils/commands/switch.to.smartview',
'csui/utils/commands/switch.to.theme',
'csui/utils/commands/switch.to.jato',
'csui/utils/commands/switch.to.classic',
'csui/utils/commands/unreserve',
'csui/utils/commands/unrequest.reservation',
'csui/utils/commands/user.profile',
'csui/utils/commands/versions',
'csui/utils/commands/versions/delete',
'csui/utils/commands/versions/download',
'csui/utils/commands/versions/open',
'csui/utils/commands/versions/promote.version',
'csui/utils/commands/versions/properties',
'csui/utils/commands/versions/open.version.perspective',
'csui/utils/commands/versions/open.version/open.version.delegate',
'csui/utils/commands/versions/lock',
'csui/utils/commands/versions/unlock',
'csui/utils/commands/filter',
'csui/utils/commands/description.toggle',
'csui/utils/commands/switch.table.mode.wrap',
'csui/utils/commands/switch.table.mode.thumbnail',
'csui/utils/commands/switch.to.proxy.user',
'csui/utils/commands/switch.to.non.proxy.user',
'csui/utils/commands/switch.to.non.cm.user',
'csui/utils/commands/table.settings',
'csui/utils/commands/table.settings.table.mode',
'csui/utils/commands/table.settings.columns',
'csui/utils/commands/table.settings.description',
'csui/utils/commands/save.filter',
'csui/utils/commands/save.query',
'csui/utils/commands/update.query',
'csui/utils/commands/maximize.widget.view',
'csui/utils/commands/restore.widget.size',
'csui/utils/commands/permissions/apply.permission',
'csui/utils/commands/permissions/edit.permission',
'csui/utils/commands/permissions/change.owner.permission',
'csui/utils/commands/permissions/delete.permission',
'csui/utils/commands/permissions/add.user.group',
'csui/utils/commands/permissions/add.owner.group',
'csui/utils/commands/permissions/restore.public.access',
'csui/utils/commands/permissions/permission.util',
'csui/utils/commands/personalize.page',
'csui/utils/commands/version.settings',
'csui/utils/commands/tree.browse',
'csui/utils/commands/content.server.administration',
'csui/utils/commands/restructure.command',
'csui/utils/commands/recycle.bin/navigate.to.recyclebin',
'csui/utils/commands/recycle.bin/purge',
'csui/utils/commands/recycle.bin/restore',
'csui/utils/commands/perspective.delete',
'csui/utils/commands/perspective.duplicate',
'csui/utils/commands/perspective.rename',
'csui/utils/commands/perspective.admin.default',
'csui/utils/commands/perspective.reset',
'csui/utils/commands/perspective.enable',
'csui/utils/commands/perspective.disable',
'csui/utils/commands/nls/localized.strings',
'csui/utils/commands/nls/root/localized.strings',
'csui/utils/commands/collection/nls/lang',
'csui/utils/commands/collection/nls/root/lang',
'json!csui/utils/commands/open.types.json',
'csui/temporary/cop/commands/open.blog',
'csui/temporary/cop/commands/open.faq',
'csui/temporary/cop/commands/open.forum',
'csui/temporary/cop/commands/open.wiki',
'csui/temporary/cop/commands/open.mailstore',
'csui/dialogs/file.open/file.open.dialog',
'csui/models/command',
'csui/models/commands',
'csui/utils/accessibility',
'csui/utils/command.error',
'csui/utils/commandhelper',
'csui/utils/commands/open.document/csui.open.document.delegates',
'csui/utils/commands/open.document/delegates/open.document.delegates',
'csui/utils/commands/versions/open.version/csui.open.version.delegates',
'csui/utils/commands/versions/open.version/delegates/open.version.delegates',
'csui/utils/commands/open.plugins/open.plugins',
'csui/utils/commands/goto.location',
'csui/utils/commands/collection/collect',
'csui/utils/node.links/node.links',
'csui/utils/routing'
],
'csui/bundles/csui-data': [
'csui/controls/icons.v2',
'csui/controls/icon/icon.view',
'csui/behaviors/default.action/default.action.behavior',
'csui/behaviors/default.action/impl/defaultaction',
'csui/behaviors/dropdown.menu/dropdown.menu.behavior',
'csui/behaviors/keyboard.navigation/retainfocus.behavior',
'csui/behaviors/keyboard.navigation/tabkey.behavior',
'csui/behaviors/widget.container/widget.container.behavior',
'csui/controls/error/error.view',
'csui/controls/globalmessage/globalmessage',
'css!csui/controls/globalmessage/globalmessage_icons',
'csui/controls/grid/grid.view',
'csui/controls/doc.preview/doc.preview.view',
'csui/controls/doc.preview/active.plugin',
'csui/controls/doc.preview/preview.plugins/preview.plugins',
'csui/controls/node-type.icon/node-type.icon.view',
'csui/controls/node-type.icon/node-type.icon.view.ext',
'csui/controls/progressblocker/blocker',
'csui/controls/globalmessage/impl/progresspanel/progresspanel.view',
'csui/controls/globalmessage/impl/progresspanel/progressbar.view',
'csui/controls/globalmessage/progresspanel.view.ext',
'csui/controls/globalmessage/message.dialog.mixin',
'csui/controls/globalmessage/progressbar.view.ext',
'csui/controls/globalmessage/impl/nls/globalmessage.lang',
'csui/controls/perspective.panel/perspective.animator',
'csui/controls/perspective.panel/perspective.panel.view',
'csui/controls/breadcrumbspanel/breadcrumbspanel.view',
'csui/controls/breadcrumbs/breadcrumbs.view',
'csui/controls/breadcrumbs/breadcrumb.view',
'csui/controls/breadcrumbs/impl/breadcrumb/breadcrumb.view',
'csui/controls/form/pub.sub',
'csui/controls/mixins/dynamic.toolitems/dynamic.toolitems.mixin',
'csui/controls/mixins/keyboard.navigation/modal.keyboard.navigation.mixin',
'csui/controls/tab.panel/tab.panel.view',
'csui/controls/tab.panel/tab.panel.view.v2',
'csui/controls/tab.panel/requiredfield/tab.contents.header.requiredfield.view',
'csui/controls/otc.menu/menu.items.view',
'csui/controls/otc.menu/menu.item.view',
'csui/controls/tab.panel/tab.links.dropdown.view',
'csui/controls/tab.panel/tab.links.ext.scroll.mixin',
'csui/controls/tab.panel/tab.links.ext.view',
'csui/controls/tab.panel/impl/tab.link.ext.view',
'csui/controls/tab.panel/tab.link.ext.view.v2',
'csui/controls/tab.panel/tab.links.ext.view.v2',
'csui/controls/tab.panel/tab.links.ext.scroll.mixin.v2',
'csui/controls/tab.panel/impl/tab.contents.view',
'csui/controls/tab.panel/behaviors/common.keyboard.behavior.mixin',
'csui/controls/tab.panel/behaviors/tab.contents.keyboard.behavior',
'csui/controls/tab.panel/behaviors/tab.contents.proxy.keyboard.behavior',
'csui/controls/tab.panel/behaviors/tab.links.dropdown.keyboard.behavior',
'csui/controls/tab.panel/behaviors/tab.links.keyboard.behavior',
'csui/controls/tab.panel/behaviors/tab.panel.keyboard.behavior',
'csui/controls/perspective.header/perspective.header.view',
'csui/controls/tab.panel/impl/tab.link.view',
'csui/controls/tab.panel/impl/tab.links.view',
'csui/controls/tab.panel/impl/nls/lang',
'csui/controls/mixins/layoutview.events.propagation/layoutview.events.propagation.mixin',
'csui/controls/mixins/view.events.propagation/view.events.propagation.mixin',
'csui/controls/mixins/global.alert/global.alert.mixin',
'csui/controls/mixins/view.state/metadata.view.state.mixin',
'csui/controls/mixins/view.state/node.view.state.mixin',
'csui/controls/mixins/view.state/toolitems.state.mixin',
'csui/controls/mixins/view.state/multi.node.fetch.mixin',
'csui/controls/mixins/view.state/node.selection.restore.mixin',
'csui/controls/mixins/search.query/search.query.mixin',
'csui/controls/tile/behaviors/blocking.behavior',
'csui/controls/tile/behaviors/infinite.scrolling.behavior',
'csui/controls/tile/behaviors/parent.scrollbar.updating.behavior',
'csui/controls/tile/behaviors/perfect.scrolling.behavior',
'csui/controls/tile/behaviors/searching.behavior',
'csui/behaviors/drag.drop/dnd.container.behaviour',
'csui/dialogs/modal.alert/modal.alert',
'csui/perspectives/flow/flow.perspective.view',
'csui/perspectives/grid/grid.perspective.view',
'csui/perspectives/left-center-right/left-center-right.perspective.view',
'csui/perspectives/banner-content-sidebar/banner-content-sidebar.perspective.view',
'csui/perspectives/sidepanel-left/sidepanel-left.perspective.view',
'csui/perspectives/sidepanel-right/sidepanel-right.perspective.view',
'csui/perspectives/single/single.perspective.view',
'csui/perspectives/tabbed/tabbed.perspective.view',
'csui/perspectives/tabbed-flow/tabbed-flow.perspective.view',
'csui/perspectives/zone/zone.perspective.view',
'csui/perspectives/mixins/perspective.edit.mixin',
'csui/perspectives/tabbed/tab.index/tab.index.preferences',
'csui/pages/start/nls/lang',
'csui/pages/start/perspective.router',
'csui/pages/start/perspective.routing',
'csui/pages/start/multi.perspective.routing',
'csui/pages/start/impl/landing.perspective.router',
'csui/pages/start/impl/node.perspective.router',
'csui/pages/start/impl/search.perspective.router',
'csui/pages/start/impl/metadata.perspective.router',
'csui/pages/start/impl/root.perspective.router',
'csui/pages/start/impl/version.perspective.router',
'csui/utils/classic.nodes/impl/core.classic.nodes',
'csui/utils/content.helper',
'csui/utils/handlebars/l10n',
'csui/utils/impl/core.defaultactionitems',
'csui/utils/non-attaching.region/non-attaching.region',
'csui/utils/non-emptying.region/non-emptying.region',
'csui/utils/script-executing.region/script-executing.region',
'csui/utils/node.links/impl/core.node.links',
'csui/utils/open.authenticated.page',
'csui/utils/smart.nodes/impl/core.smart.nodes',
'csui/utils/taskqueue',
'csui/behaviors/keyboard.navigation/tabables.behavior',
'csui/behaviors/keyboard.navigation/tabable.region.behavior',
'csui/utils/commands/open.plugins/impl/brava.plugin',
'csui/models/node/node.addable.type.factory',
'csui/controls/perspective.panel/perspective.factory',
'csui/utils/contexts/browsing/browsing.context',
'csui/utils/contexts/impl/csui.context.plugin',
'csui/utils/contexts/portal/portal.context',
'csui/utils/contexts/perspective/impl/landing.perspective.context.plugin',
'csui/utils/contexts/perspective/plugins/node/node.perspective.context.plugin',
'csui/utils/contexts/perspective/impl/search.perspective.context.plugin',
'csui/utils/contexts/perspective/plugins/search.perspective.context.plugin',
'csui/utils/contexts/perspective/impl/metadata.perspective.context.plugin',
'csui/utils/contexts/perspective/impl/root.perspective.context.plugin',
'csui/utils/contexts/perspective/impl/version.perspective.context.plugin',
'csui/utils/contexts/perspective/plugins/node/main.node.extra.data',
'csui/utils/contexts/perspective/plugins/node/node.extra.data',
'csui/utils/contexts/perspective/plugins/node/impl/csui.node.extra.data',
'csui/utils/contexts/perspective/plugins/node/impl/csui.main.node.extra.data',
'csui/utils/contexts/perspective/plugins/node/utils/implement.extra.data',
'csui/utils/contexts/perspective/plugins/node/utils/merge.extra.data',
'csui/utils/contexts/perspective/landing.perspectives',
'csui/utils/contexts/perspective/node.perspectives',
'csui/utils/contexts/perspective/perspective.context',
'csui/utils/contexts/perspective/perspective.guide',
'csui/utils/contexts/perspective/perspective.context.plugin',
'csui/utils/contexts/perspective/search.perspectives',
'csui/utils/contexts/factories/ancestors',
'csui/utils/contexts/factories/appcontainer',
'csui/utils/contexts/factories/children',
'csui/utils/contexts/factories/children2',
'csui/utils/contexts/factories/columns',
'csui/utils/contexts/factories/columns2',
'csui/utils/contexts/factories/global.error',
'csui/utils/contexts/factories/node',
'csui/utils/contexts/factories/next.node',
'csui/utils/contexts/factories/previous.node',
'csui/utils/contexts/factories/version',
'csui/utils/contexts/factories/next.version',
'csui/utils/contexts/factories/user',
'csui/utils/contexts/factories/usernodepermission',
'csui/utils/contexts/factories/volume',
'csui/utils/contexts/factories/application.scope.factory',
'csui/utils/contexts/factories/favoritescolumns',
'csui/utils/contexts/factories/favorite2groups',
'csui/utils/contexts/factories/favorites',
'csui/utils/contexts/factories/favorites2',
'csui/utils/contexts/factories/favorite2columns',
'csui/utils/contexts/factories/recentlyaccessedcolumns',
'csui/utils/contexts/factories/recentlyaccessed',
'csui/utils/contexts/factories/recycle.bin',
'csui/utils/contexts/factories/recycle.items.columns.factory',
'csui/utils/contexts/factories/recycle.items',
'csui/utils/contexts/factories/member',
'csui/utils/contexts/factories/search.box.factory',
'csui/utils/contexts/factories/search.formquery.factory',
'csui/utils/contexts/factories/search.metadata.factory',
'csui/utils/contexts/factories/search.query.factory',
'csui/utils/contexts/factories/metadata.factory',
'csui/utils/contexts/factories/task.queue.factory',
'csui/utils/contexts/factories/server.info',
'csui/utils/contexts/factories/search.settings.factory',
'csui/utils/contexts/factories/largefilesettings.factory',
'csui/utils/contexts/factories/objecttypes.factory',
'csui/utils/contexts/factories/branding.config.factory',
'csui/utils/contexts/factories/widget.settings.collection.factory',
'csui/pages/start/impl/location',
'csui/themes/csui.jato.action.icons',
'csui/themes/csui.jato.status.icons',
'csui/themes/csui.jato.mime.illustrations',
'json!csui/utils/contexts/perspective/impl/perspectives/document.overview.json',
'json!csui/utils/contexts/perspective/impl/perspectives/version.overview.json',
'json!csui/utils/contexts/perspective/impl/perspectives/favorites2.table.json',
'json!csui/utils/contexts/perspective/impl/perspectives/container.json',
'json!csui/utils/contexts/perspective/impl/perspectives/metadata.json',
'json!csui/utils/contexts/perspective/impl/perspectives/metadata.navigation.json',
'json!csui/utils/contexts/perspective/impl/perspectives/recentlyaccessedtable.json',
'json!csui/utils/contexts/perspective/impl/perspectives/search.json',
'json!csui/utils/contexts/perspective/impl/perspectives/saved.query.json',
'json!csui/utils/contexts/perspective/impl/perspectives/user.json',
'json!csui/utils/contexts/perspective/impl/perspectives/recycleitems.table.json',
'csui/widgets/error/error.view',
'csui/models/widget/myassignments.model',
'csui/models/widget/recentlyaccessed.model',
'csui/models/widget/recycle.items.model',
'csui/models/sidebar.item',
'csui/temporary/activeviews/icons/icons',
'csui/temporary/appearances/icons/icons',
'csui/temporary/cop/icons/icons',
'csui/models/widget/nls/lang',
'csui/pages/start/impl/nls/lang',
'csui/perspectives/impl/nls/lang'
],
'csui/bundles/csui-app': [
'csui/behaviors/expanding/expanding.behavior',
'csui/behaviors/item.error/item.error.behavior',
'csui/behaviors/item.state/item.state.behavior',
'csui/behaviors/item.state/item.state.view',
'csui/behaviors/limiting/limiting.behavior',
'csui/behaviors/resizable/resizable.behavior',
'csui/controls/tile/behaviors/expanding.behavior',
'csui/controls/tile/tile.view',
'csui/controls/iconpreload/icon.preload.view',
'csui/controls/rich.text.editor/rich.text.editor',
'csui/controls/selected.count/selected.count.view',
'csui/controls/selected.count/selected.count.control.view',
'csui/lib/jquery.simulate',
'csui/lib/othelp',
'csui/utils/froala/bootstrap',
'csui/pages/start/start.page.view',
'csui/pages/start/pendo.dialog.view',
'csui/widgets/navigation.header/controls/help/help.view',
'csui/widgets/navigation.header/controls/home/home.view',
'csui/widgets/navigation.header/controls/breadcrumbs/breadcrumbs.view',
'csui/widgets/navigation.header/controls/search/search.view',
'csui/widgets/navigation.header/controls/favorites/favorites.view',
'csui/widgets/navigation.header/controls/user.profile/user.profile.view',
'csui/widgets/navigation.header/controls/progressbar.maximize/progressbar.maximize.view',
'csui/widgets/navigation.header/navigation.header.controls',
'csui/controls/app.header/app.header.controls/logo/logo.view',
'csui/controls/app.header/app.header.controls/search.box/search.box.view',
'csui/controls/app.header/app.header.controls/progresspanel/progressbar.maximize.view',
'csui/controls/app.header/app.header.controls/favorites/favorites.view',
'csui/controls/app.header/app.header.controls/help/help.view',
'csui/controls/app.header/app.header.controls/user.profile/user.profile.view',
'csui/controls/app.header/app.header.controls/csui.app.header.controls',
'csui/controls/app.header/burger.menu/burger.menu',
'csui/utils/proxysettings/proxy.dynamic.menu',
'csui/utils/usersettings/cm.dynamic.menu',
'csui/perspective.manage/sidebar/pman.sidebar.container.view',
'csui/perspective.manage/sidebar/layouts',
'csui/perspective.manage/sidebar/widgets',
'csui/controls/tabletoolbar/impl/nls/localized.strings',
'csui/controls/tabletoolbar/impl/nls/localized.strings',
'json!csui/utils/contexts/perspective/impl/perspectives/error.global.json',
'csui/widgets/error.global/error.global.view',
'csui/widgets/favorites/favorites.view',
'csui/widgets/favorites/tileview.toolbaritems',
'csui/widgets/navigation.header/profile.menuitems',
'csui/widgets/navigation.header/profile.menuitems.mask',
'csui/widgets/placeholder/placeholder.view',
'csui/widgets/recentlyaccessed/recentlyaccessed.columns',
'csui/widgets/recentlyaccessed/recentlyaccessed.view',
'csui/widgets/recentlyaccessed/tileview.toolbaritems',
'csui/widgets/search.box/search.box.view',
'csui/widgets/shortcut/shortcut.view',
'csui/widgets/shortcuts/shortcuts.view',
'csui/widgets/welcome.placeholder/welcome.placeholder.view',
'csui/widgets/html.editor/impl/cslink.preview/cslink.preview.view',
'csui/widgets/html.editor/html.editor.view',
'csui/widgets/document.overview/document.overview.view',
'csui/widgets/version.overview/version.overview.view',
'json!csui/widgets/error.global/error.global.manifest.json',
'json!csui/widgets/favorites/favorites.manifest.json',
'json!csui/widgets/placeholder/placeholder.manifest.json',
'json!csui/widgets/recentlyaccessed/recentlyaccessed.manifest.json',
'json!csui/widgets/shortcut/shortcut.manifest.json',
'json!csui/widgets/shortcuts/shortcuts.manifest.json',
'json!csui/widgets/welcome.placeholder/welcome.placeholder.manifest.json',
'json!csui/widgets/recycle.items.table/recycle.items.table.manifest.json',
'json!csui/widgets/html.editor/html.editor.manifest.json',
'json!csui/widgets/document.overview/document.overview.manifest.json',
'csui/widgets/favorites/impl/nls/favorites.manifest',
'csui/widgets/placeholder/impl/nls/placeholder.manifest',
'csui/widgets/recentlyaccessed/impl/nls/recentlyaccessed.manifest',
'csui/widgets/shortcut/impl/nls/shortcut.manifest',
'csui/widgets/shortcuts/impl/nls/shortcuts.manifest',
'csui/widgets/welcome.placeholder/impl/nls/welcome.placeholder.manifest',
'csui/widgets/recycle.items.table/impl/nls/recycle.items.table.manifest',
'csui/widgets/html.editor/impl/nls/html.editor.manifest',
'csui/widgets/document.overview/impl/nls/document.overview.manifest',
'csui/widgets/favorites/impl/nls/lang',
'csui/widgets/recentlyaccessed/impl/nls/lang',
'csui/widgets/search.forms/impl/nls/lang'
],
'csui/bundles/csui-view-support': [
'csui/lib/ally',
'csui/lib/bootstrap3-typeahead',
'csui/lib/jquery.mousehover',
'csui/lib/fancytree/jquery.fancytree',
'csui/lib/fancytree/jquery.fancytree.filter',
'csui/behaviors/collection.error/collection.error.behavior',
'csui/behaviors/collection.state/collection.state.behavior',
'csui/behaviors/collection.state/collection.state.view',
'csui/controls/tableactionbar/tableactionbar.view',
'csui/controls/dialog/dialog.view',
'csui/controls/dialog/impl/header.view',
'csui/controls/dialog/footer.view',
'csui/controls/facet.bar/facet.bar.view',
'csui/controls/facet.panel/facet.panel.view',
'csui/controls/list/behaviors/list.view.keyboard.behavior',
'csui/controls/list/emptylist.view',
'csui/controls/list/list.view',
'csui/controls/list/list.state.view',
'csui/controls/treebrowse/node.tree.view',
'css!csui/controls/list/impl/list',
'csui/controls/list/simplelist.view',
'csui/controls/list/simpletreelist.view',
'csui/controls/listitem/inline.menu.view',
'csui/controls/listitem/listitemobject.view',
'csui/controls/listitem/listitemstandard.view',
'csui/controls/list/behaviors/list.item.keyboard.behavior',
'csui/controls/listitem/listitemstateful.view',
'csui/controls/listitem/simpletreelistitem.view',
'csui/controls/table/cells/search/search.cell/search.cell.popover.list.view',
'csui/controls/toolbar/toolbar.view',
'csui/controls/toolbar/toolbar.command.controller',
'csui/controls/toolbar/toolitem.model',
'csui/controls/toolbar/toolitem.custom.view',
'csui/controls/toolbar/toolitem.view',
'csui/controls/toolbar/flyout.toolitem.view',
'csui/controls/toolbar/otctoolbar/otctoolbar.view',
'csui/controls/toolbar/otctoolbar/otcdelayed.toolbar.view',
'csui/controls/toolbar/otctoolbar/otctoolitems.view',
'csui/controls/item.title/impl/otcdropdown.menu/menu.toolitem.view',
'csui/controls/item.title/impl/otcdropdown.menu/submenu.toolitem.view',
'csui/controls/toolbar/toolitems.factory',
'csui/controls/toolbar/toolitems.filtered.model',
'csui/controls/toolbar/toolitems.mask',
'csui/controls/toolbar/delayed.toolbar.view',
'csui/controls/toolbar/toolbar.state.behavior',
'hbs!csui/controls/toolbar/toolitem',
'csui/controls/fileupload/impl/upload.controller',
'csui/controls/checkbox/checkbox.view',
'csui/controls/disclosure/disclosure.view',
'csui/controls/listitem/impl/nls/lang',
'csui/controls/fileupload/impl/nls/lang',
'csui/models/appliedcategories',
'csui/models/appliedcategory',
'csui/models/fileupload',
'csui/models/fileuploads',
'csui/models/namequery',
'csui/models/nodeversions',
'csui/models/versions',
'csui/models/facet',
'csui/models/facets',
'csui/models/facettopic',
'csui/models/facettopics',
'csui/models/node.facets/facet.query.mixin',
'csui/models/node.facets2/facet.query.mixin',
'csui/models/widget/search.results/search.facet.query.mixin',
'csui/models/node/node.facet.factory',
'csui/models/node/node.facet2.factory',
'csui/models/widget/recycle.items/recycle.items.facets.factory',
'csui/models/nodefacets',
'csui/models/nodefacets2',
'csui/models/widget/search.results/search.results.model',
'csui/models/permission/permission.table.columns.model',
'csui/models/widget/recycle.items/recycle.items.facets',
'csui/utils/commands/impl/full.page.modal/full.page.modal.view',
'csui/controls/full.page.modal/full.page.modal.view',
'csui/utils/thumbnail/thumbnail.object',
'csui/utils/thumbnail/thumbnail.view',
'csui/utils/expiration.warning/expiration.warning.dialog',
'csui/utils/commands/open.plugins/impl/core.open.plugins',
'csui/utils/contexts/factories/search.results.factory',
'csui/utils/high.contrast/detector',
'csui/utils/impl/signin.dialog/signin.dialog',
'csui/utils/toolitem.masks/global.toolitems.mask',
'csui/utils/responsivecontainer',
'csui/utils/proxy',
'css!csui/controls/form/impl/form',
'csui/widgets/metadata/metadata.forms',
'csui/widgets/search.results/controls/sorting/sort.menu.view',
'csui/widgets/metadata/impl/metadata.forms',
'csui/widgets/metadata/impl/metadata.utils',
'csui/widgets/metadata/impl/nls/lang',
'csui/models/appliedcategoryform',
'csui/models/appliedcategories/appliedcategoriesaction',
'csui/models/form',
'csui/models/forms',
'csui/models/nodecreateforms',
'csui/models/nodeforms',
'csui/models/nodeupdateforms',
'csui/controls/multilingual.text.picker/impl/multilingual.form.view',
'csui/controls/multilingual.text.picker/multilingual.popover.mixin',
'csui/controls/multilingual.text.picker/impl/nls/lang',
'csui/temporary/cop/commands/defaultactionitems',
'csui/temporary/activeviews/commands/defaultactionitems',
'csui/temporary/appearances/commands/defaultactionitems',
'csui/models/node.facets/server.adaptor.mixin',
'csui/models/node.facets2/server.adaptor.mixin',
'csui/widgets/metadata/metadata.forms/server.adaptor.mixin',
'csui/models/appliedcategories/server.adaptor.mixin',
'csui/models/appliedcategories/category.action.server.adaptor.mixin',
'csui/models/namequery/server.adaptor.mixin',
'csui/models/widget/recycle.items/facet.server.adaptor.mixin',
'csui/utils/user.avatar.color',
'csui/utils/letter-avatar-random-color/letter-avatar-colors',
'csui/controls/mixins/dynamic.toolitems/reopening.toolbar.mixin',
'csui/controls/node-type.icon/node-type.icon.item.view.mixin'
],
'csui/bundles/csui-browse': [
'csui/behaviors/item.name/item.name.behavior',
'csui/behaviors/table.rowselection.toolbar/table.rowselection.toolbar.behavior',
'csui/controls/conflict.resolver/impl/conflict.dialog/conflict.dialog',
'csui/controls/conflict.resolver/impl/collection.conflicts/collection.conflicts.view',
'csui/controls/conflict.resolver/conflict.resolver',
'csui/controls/side.panel/side.panel.view',
'csui/controls/draganddrop/draganddrop.view',
'csui/controls/fileupload/fileupload',
'csui/controls/settings/settings.view',
'csui/controls/table/rows/description/search.description.view',
'csui/controls/draganddrop/impl/nls/lang',
'csui/controls/fileupload/impl/addversion.controller',
'csui/controls/pagination/nodespagination.view',
'csui/controls/item.title/item.title.view',
'csui/controls/table/table.columns',
'csui/controls/table/table.view',
'csui/controls/table.list/table.list.view',
'csui/controls/table/inlineforms/inlineform.factory',
'csui/controls/tabletoolbar/nls/localized.strings',
'csui/controls/tabletoolbar/tabletoolbar.view',
'csui/controls/table.configuration.toolbar/configuration.toolbar.dropdown.view',
'csui/controls/table.rowselection.toolbar/table.rowselection.toolbar.view',
'csui/controls/table/inlineforms/inlineform/inlineform.schemas',
'csui/controls/table/inlineforms/inlineform/impl/csui.inlineform.schemas',
'csui/controls/table/inlineforms/base/inline.edit.view',
'csui/controls/table/inlineforms/base/base.inline.form.view',
'csui/controls/table/inlineforms/base/views/textfield/textfield.view',
'csui/controls/table/inlineforms/base/views/selectfield/selectfield.view',
'csui/controls/table/inlineforms/base/views/textfield/multilingual.textfield.view',
'csui/controls/table/inlineforms/favorite/favorite.view',
'csui/controls/table/inlineforms/generic/generic.view',
'csui/controls/table/inlineforms/inlineform/inlineform.view',
'csui/controls/table/inlineforms/inlineform/impl/inlineform.view',
'csui/controls/table/inlineforms/inlineform.registry',
'csui/controls/table/inlineforms/permissions/user.picker/user.picker.view',
'csui/controls/table/inlineforms/folder/folder.view',
'csui/controls/table/cells/cell/cell.view',
'csui/controls/table/cells/celleditor/celleditor.view',
'csui/controls/table/cells/cell.factory',
'csui/controls/table/cells/cell.registry',
'csui/controls/table/cells/date/date.view',
'csui/controls/table/cells/description/description.view',
'csui/controls/table/cells/datetime/datetime.view',
'csui/controls/table/cells/duedate/duedate.view',
'csui/controls/table/cells/favorite/favorite.view',
'csui/controls/table/cells/member/member.view',
'csui/controls/table/cells/name/name.view',
'csui/controls/table/cells/node.state/node.state.view',
'csui/controls/table/cells/parent/parent.view',
'csui/controls/table/cells/priority/priority.view',
'csui/controls/table/cells/reservation/reservation.view',
'csui/controls/table/cells/searchbox/searchbox.view',
'csui/controls/table/cells/select/select.view',
'csui/controls/table/cells/size/size.view',
'csui/controls/table/cells/status/status.view',
'csui/controls/table/cells/templated/templated.view',
'csui/controls/table/cells/text/text.view',
'csui/controls/table/cells/type.icon/type.icon.view',
'csui/controls/table/cells/user/user.view',
'csui/controls/table/cells/permission/permission.level.view',
'csui/controls/tree/tree.view',
'csui/controls/node.state/node.states.view',
'csui/controls/node.state/node.state.icons',
'csui/controls/node.state/impl/node.state.icons',
'csui/controls/table/rows/description/description.view',
'csui/controls/table/rows/metadata/metadatarow.view',
'csui/controls/thumbnail/thumbnail.view',
'csui/controls/thumbnail/thumbnail.content',
'csui/controls/thumbnail/content/content.registry',
'csui/controls/thumbnail/content/content.factory',
'csui/controls/thumbnail/content/favorite/favorite.view',
'csui/controls/thumbnail/content/name/name.view',
'csui/controls/thumbnail/content/member/member.view',
'csui/controls/thumbnail/content/thumbnail.icon/thumbnail.icon.view',
'csui/controls/thumbnail/content/overview/overview.view',
'csui/controls/thumbnail/content/select/select.view',
'csui/controls/thumbnail/content/size/size.view',
'csui/controls/thumbnail/content/date/date.view',
'csui/controls/thumbnail/content/node.state/node.state.view',
'csui/controls/thumbnail/content/node.state/impl/node.state.icons',
'csui/controls/thumbnail/content/node.state/impl/reservation/reservation.view',
'csui/controls/thumbnail/content/overview/overview.content',
'csui/controls/thumbnail/content/overview/properties.overview',
'csui/controls/thumbnail/content/thumbnail.icon/gallery.plugin.view',
'csui/controls/zipanddownload/impl/preflight.dialog/preflight.dialog.view',
'csui/controls/zipanddownload/impl/download.dialog/download.dialog.view',
'csui/controls/wizard/wizard.view',
'csui/controls/wizard/step/footer.view',
'csui/controls/wizard/step/wizard.step.view',
'csui/dialogs/members.picker/members.picker.dialog',
'csui/dialogs/node.picker/node.picker',
'csui/dialogs/node.picker/node.picker.v2',
'csui/dialogs/node.picker/data/node.picker.extra.data',
'csui/dialogs/node.picker/data/impl/csui.node.picker.extra.data',
'csui/dialogs/multilingual.text.picker/multilingual.text.picker',
'csui/dialogs/restructure/restructure.dialog',
'csui/dialogs/node.picker/impl/header/apply.properties.selector/apply.properties.selector.view',
'csui/controls/multilingual.text.picker/multilingual.text.picker',
'csui/dialogs/node.picker/start.locations/location.base.factory',
'csui/dialogs/node.picker/start.locations/node.base.factory',
'csui/dialogs/node.picker/start.locations/start.location.collection',
'csui/dialogs/node.picker/start.locations/current.location/current.location.factory',
'csui/dialogs/node.picker/start.locations/enterprise.volume/enterprise.volume.factory',
'csui/dialogs/node.picker/start.locations/favorites/favorites.factory',
'csui/dialogs/node.picker/start.locations/personal.volume/personal.volume.factory',
'csui/dialogs/node.picker/start.locations/category.volume/category.volume.factory',
'csui/dialogs/node.picker/start.locations/perspective.assets.volume/perspective.assets.volume.factory',
'csui/dialogs/node.picker/start.locations/recent.containers/recent.containers.factory',
'csui/dialogs/node.picker/start.locations/search.location/search.location.factory',
'csui/dialogs/node.picker/start.locations/default.location/default.location.factory',
'csui/dialogs/node.picker/start.locations/support.assets.volume/support.assets.volume.factory',
'csui/dialogs/members.picker/members.picker.wizard',
'csui/dialogs/members.picker/start.locations/location.base.factory',
'csui/dialogs/members.picker/start.locations/start.location.collection',
'csui/dialogs/members.picker/start.locations/current.group/current.group.factory',
'csui/dialogs/members.picker/start.locations/all.members/all.members.factory',
'csui/dialogs/members.picker/start.locations/member.groups/member.groups.factory',
'csui/dialogs/members.picker/start.locations/recent.groups/recent.groups.factory',
'csui/dialogs/members.picker/start.locations/all.groups/all.groups.factory',
'csui/dialogs/members.picker/start.locations/acl.groups/acl.groups.factory',
'csui/dialogs/members.picker/start.locations/acl.groups/impl/acl.groups.collection',
'csui/models/permission/acl.group.server.adaptor.mixin',
'csui/integration/folderbrowser/folderbrowser.widget',
'csui/integration/folderbrowser2/folderbrowser2.widget',
'csui/integration/folderbrowser2/container.enforcer',
'csui/integration/target.picker/target.picker',
'csui/integration/v1.widgets.wrapper',
'csui/integration/permission.header/permission.header.view',
'csui/integration/permission/table/cells/security.permission.cell',
'csui/integration/permission/table/permission.table.columns',
'csui/integration/folderbrowser/impl/nodestable.toolitems',
'csui/lib/jquery.dataTables.bootstrap/js/dataTables.bootstrap',
'csui/lib/jquery.dataTables/js/jquery.dataTables',
'csui/lib/jquery.dataTables.tableTools/js/dataTables.tableTools',
'csui/widgets/search.results/impl/search.results.factory',
'css!csui/widgets/search.results/impl/search.results',
'csui/widgets/nodestable/nodestable.view',
'csui/utils/testutils/async.test.utils',
'csui/utils/toolitem.masks/children.toolitems.mask',
'csui/utils/toolitem.masks/creation.toolitems.mask',
'csui/widgets/favorites2.table/toolbaritems',
'csui/widgets/favorites2.table/toolbaritems.masks',
'csui/widgets/nodestable/headermenuitems',
'csui/widgets/nodestable/headermenuitems.mask',
'csui/widgets/nodestable/toolbaritems',
'csui/widgets/nodestable/toolbaritems.masks',
'csui/widgets/recentlyaccessedtable/toolbaritems',
'csui/widgets/recentlyaccessedtable/toolbaritems.masks',
'csui/widgets/favorites2.table/favorites2.table.view',
'csui/widgets/favorites/favorite.star.view',
'csui/widgets/favorites/favorite.star.view.mixin',
'csui/widgets/recentlyaccessedtable/recentlyaccessedtable.view',
'csui/widgets/recycle.items.table/recycle.items.table.view',
'csui/widgets/recycle.items.table/recycle.items.table.header.view',
'csui/widgets/permissions/permissions.view',
'csui/widgets/permissions/impl/edit/permission.level.selector/permission.level.selector.view',
'csui/widgets/permissions/impl/edit/edit.permission.helper',
'csui/widgets/permissions/impl/permissions.list/toolbaritems',
'csui/widgets/permissions/impl/permissions.list/toolbaritems.masks',
'csui/widgets/permissions/impl/permissions.list/permissions.dropdown.menu.items',
'csui/widgets/permissions/impl/permissions.lookup/permissions.lookup.view',
'csui/widgets/permissions/edit/apply.permission/apply.permission.view',
'csui/widgets/permissions/edit/permission.level.selector/permission.level.selector.view',
'csui/widgets/permissions/edit/permission.attributes/permission.attributes.view',
'csui/widgets/permissions/edit/apply.permission/header/apply.permission.header.view',
'csui/widgets/permissions/impl/edit/apply.permission/impl/header/apply.permission.header.view',
'csui/widgets/permissions/edit/edit.permission.helper',
'csui/widgets/permissions/nls/lang',
'csui/widgets/permissions/dynamic.permissions/toolbaritems',
'csui/widgets/permissions/dynamic.permissions/toolbaritems.masks',
'csui/widgets/permissions/dynamic.permissions/header.action.items',
'csui/widgets/permissions/dynamic.permissions/header.action.items.masks',
'csui/controls/tablesettings/table.settings.dropdown.view',
'csui/controls/versionsettings/version.settings.view',
'csui/controls/version.control.dialog/version.control.dialog.view',
'csui/controls/version.control.dialog/document.version.control.view',
'csui/controls/version.control.dialog/add.version.control.view',
'csui/controls/version.control.dialog/disable.version.settings.view',
'json!csui/widgets/nodestable/nodestable.manifest.json',
'csui/widgets/nodestable/impl/nls/nodestable.manifest',
'csui/utils/dragndrop.supported.subtypes',
'csui/utils/permissions/permissions.precheck'
],
'csui/bundles/csui-forms': [
'csui/controls/form/form.view',
'csui/controls/form/fields/radiofield.view',
'csui/controls/form/fields/alpaca/alpuserfield',
'csui/controls/form/fields/alpaca/alpcsuibooleanfield',
'csui/controls/form/fields/alpaca/alpcsuicheckboxV2',
'csui/controls/form/fields/alpaca/alpcsuiselectfield',
'csui/controls/form/fields/alpaca/alpcsuidateonlyfield',
'csui/controls/form/fields/alpaca/alpcsuidatetimefield',
'csui/controls/form/fields/alpaca/alpcsuitextfield',
'csui/controls/form/fields/alpaca/alpcsuimultilingual.textfield',
'csui/controls/form/fields/alpaca/alpcsuitextareafield',
'csui/controls/form/fields/alpaca/alpcsuiintegerfield',
'csui/controls/form/fields/alpaca/alpcsuiurlfield',
'csui/controls/form/fields/alpaca/alpcsuiarrayfield',
'csui/controls/form/fields/alpaca/alpcsuiobjectfield',
'csui/controls/form/fields/alpaca/alpnodepickerfield',
'csui/controls/form/fields/alpaca/alpcsuiarraybuttonsfield',
'csui/controls/form/fields/alpaca/alpcsuipasswordfield',
'csui/controls/form/fields/alpaca/alpcsuitklfield',
'csui/controls/form/fields/alpaca/alpcsuipickerfield.mixin',
'csui/controls/form/fields/alpaca/alptypeaheadfield.mixin',
'csui/controls/form/fields/typeaheadfield.view',
'csui/controls/form/fields/typeaheadfield.view.mixin',
'csui/controls/form/fields/userfield.view',
'csui/controls/form/fields/booleanfield.view',
'csui/controls/form/fields/datefield.view',
'csui/controls/form/fields/datetimefield.view',
'csui/controls/form/fields/selectfield.view',
'csui/controls/form/fields/textfield.view',
'csui/controls/form/fields/multilingual.textfield.view',
'csui/controls/form/fields/textareafield.view',
'csui/controls/form/fields/multilingual.textareafield.view',
'csui/controls/form/fields/nodepickerfield.view',
'csui/controls/form/fields/arraybuttonsfield.view',
'csui/controls/form/colout/colout.view',
'csui/controls/form/fields/tklfield.view',
'csui/controls/userpicker/roles/user.view',
'csui/controls/userpicker/roles/group.view',
'csui/controls/userpicker/userpicker.view',
'csui/controls/userpicker/core.userpicker.roles',
'csui/controls/userpicker/impl/user.view',
'csui/controls/typeaheadpicker/typeaheadpicker.view',
'csui/controls/typeaheadpicker/impl/typeaheaditem.view',
'csui/controls/form/fields/base/csformfield.view',
'csui/controls/form/fields/base/csformfield.editable.behavior',
'csui/controls/form/fields/base/csformfield.states.behavior',
'csui/controls/form/fields/base/csformarrayfield.editable.behavior',
'csui/controls/form/fields/base/csformarrayfield.states.behavior',
'csui/utils/usersettings/usersettings.tabs/usersettings.tabs',
'csui/utils/usersettings/usersettings.tabs/core.usersettings.tabs',
'csui/utils/usersettings/usersettings.tabs/usersettings.tabs.view',
'csui/utils/usersettings/usersettings',
'csui/utils/usersettings/impl/usersettings.model',
'csui/utils/userprofilesessions/userprofilesessions.tabs/userprofilesessions.tabs',
'csui/utils/userprofilesessions/userprofilesessions.tabs/core.userprofilesessions.tabs',
'csui/utils/userprofilesessions/userprofilesessions.tabs/userprofilesessions.tabs.view',
'csui/utils/userprofilesessions/userprofilesessions',
'csui/utils/userprofilesessions/impl/userprofilesessions.model',
'csui/utils/proxysettings/proxysettings',
'csui/utils/proxysettings/proxysettings.tabs/core.proxysettings.tabs',
'csui/utils/proxysettings/proxysettings.tabs/proxysettings.tabs',
'csui/utils/proxysettings/proxysettings.tabs/proxysettings.tabs.view',
'csui/utils/contexts/factories/user.profile.settings.factory',
'csui/lib/alpaca/js/alpaca.lite',
'csui/lib/alpaca/nls/lang',
'csui/controls/form/impl/nls/lang',
'csui/controls/form/impl/fields/csformfield.view',
'hbs!csui/controls/form/impl/fields/typeaheadfield/typeaheadfield',
'css!csui/controls/form/impl/fields/typeaheadfield/typeaheadfield',
'css!csui/controls/form/impl/fields/userfield/userfield'
],
'csui/bundles/csui-metadata': [
'csui/controls/tableheader/comment/comment.button.view',
'csui/widgets/metadata/versions.toolbaritems',
'csui/widgets/metadata/impl/metadata.tabcontentcollection.view',
'csui/widgets/metadata/impl/header/rightbar/toolbaritems',
'csui/widgets/metadata/impl/header/rightbar/toolbaritems.masks',
'csui/utils/versions.default.action.items',
'csui/widgets/metadata/metadata.view',
'csui/widgets/metadata/metadata.properties.view',
'csui/widgets/metadata/metadata.action.one.item.properties.view',
'csui/widgets/metadata/metadata.add.categories.controller',
'csui/widgets/metadata/metadata.add.document.controller',
'csui/widgets/metadata/impl/add.items/metadata.add.item.controller',
'csui/widgets/metadata/metadata.add.item.controller',
'csui/widgets/metadata/metadata.copy.move.items.controller',
'csui/widgets/metadata/property.panels/general/metadata.general.property.controller',
'csui/widgets/metadata/impl/metadatanavigation/metadatanavigation.view',
'csui/widgets/metadata.navigation/metadata.navigation.view',
'csui/widgets/metadata/impl/add.items/metadata.add.multiple.items.controller',
'csui/widgets/metadata/impl/header/item.name/metadata.item.name.view',
'csui/widgets/metadata/metadata.save.query.controller',
'json!csui/widgets/metadata/metadata.manifest.json',
'json!csui/widgets/metadata.navigation/metadata.navigation.manifest.json',
'csui/widgets/metadata/impl/nls/metadata.manifest',
'csui/widgets/metadata.navigation/impl/nls/metadata.navigation.manifest',
'csui/widgets/metadata/add.properties.menuitems',
'csui/widgets/metadata/add.properties.menuitems.mask',
'csui/widgets/metadata/header.dropdown.menu.items',
'csui/widgets/metadata/header.dropdown.menu.items.mask',
'csui/widgets/metadata/versions.toolbaritems.mask',
'csui/widgets/metadata/metadata.general.action.fields',
'csui/widgets/metadata/metadata.versions.view',
'csui/widgets/metadata/metadata.audit.view'
],
'csui/bundles/csui-search': [
'csui/models/widget/search.results/facet.server.adaptor.mixin',
'csui/models/widget/search.results/search.facets',
'csui/utils/contexts/factories/search.results.facets.factory',
'csui/models/widget/search.results/object.to.model',
'csui/widgets/search.custom/search.custom.view',
'csui/widgets/search.custom/impl/search.object.view',
'csui/widgets/search.custom/impl/search.customquery.factory',
'csui/widgets/search.forms/search.form.view',
'csui/widgets/search.forms/search.form.model',
'csui/widgets/search.forms/search.form.factory',
'csui/widgets/search.results/search.results.view',
'json!csui/widgets/search.custom/search.custom.manifest.json',
'json!csui/widgets/search.results/search.results.manifest.json',
'csui/widgets/search.custom/impl/nls/search.custom.manifest',
'csui/widgets/search.results/impl/nls/search.results.manifest',
'csui/widgets/search.results/impl/toolbaritems',
'csui/widgets/search.results/toolbaritems',
'csui/widgets/search.results/toolbaritems.masks'
],
'csui/bundles/csui-visualisation': [
'csui/lib/d3',
'csui/controls/charts/visual.count/visual.count.view'
],
'csui/bundles/csui-perspective': [
'csui/perspective.manage/pman.view',
'csui/perspective.manage/pman.view.branding',
'csui/perspective.manage/landing.page.pman.view',
'csui/perspective.manage/branding.view',
'csui/perspective.manage/jato/branding.view',
'csui/perspective.manage/settings.panel/settings.panel.view',
'csui/perspective.manage/jato/settings.panel/settings.panel.view',
'csui/perspective.manage/behaviours/pman.widget.config.behaviour',
'csui/perspective.manage/widgets/perspective.placeholder/perspective.placeholder.view',
'csui/perspective.manage/widgets/perspective.widget/perspective.widget.view',
'csui/perspective.manage/settings.panel/settings/icons.setting/icons.setting.view',
'csui/perspective.manage/settings.panel/settings/icon.settings',
'json!csui/perspective.manage/widgets/perspective.placeholder/perspective.placeholder.manifest.json',
'json!csui/perspective.manage/widgets/perspective.widget/perspective.widget.manifest.json',
'csui/perspective.manage/widgets/perspective.placeholder/impl/nls/perspective.placeholder.manifest',
'csui/perspective.manage/widgets/perspective.widget/impl/nls/perspective.widget.manifest'
],
'csui/bundles/csui-icons-controls': [
'csui/controls/checkbox/checkbox.icons.v2',
'csui/controls/disclosure/disclosure.icons.v2'
],
'csui/bundles/csui-icons-actions': [
'csui/themes/carbonfiber/action_icons'
],
'csui/bundles/csui-ot-icons': [
'csui/themes/carbonfiber/ot-icons/icons_csui_action',
'csui/themes/carbonfiber/ot-icons/icons_csui_action_16',
'csui/themes/carbonfiber/ot-icons/icons_csui_header'
],
'csui/bundles/csui-icons-mimetype': [
'csui/themes/carbonfiber/mimetype_icons'
],
'csui/bundles/csui-icons-mimetype-colorschema': [
'csui/themes/carbonfiber/mimetype_colorschema_icons'
],
'csui/bundles/csui-alpaca-legacy': [
'csui/lib/alpaca/js/alpaca'
]
  }
});